import * as React from 'react';

import {EmptyStateLarge} from 'shells/empty-states/empty-state-large';
import {Illustration} from 'shells/illustrations/illustration';

import {useGetAudienceForEntityList} from '../graphql/hooks/use-get-audience-for-entity-list';

import styles from './audience-is-building-view.module.css';

type Props = {
    audienceId: string;
    currentCount: number;
};

export function AudienceIsBuildingView(props: Props) {
    const {audience} = useGetAudienceForEntityList(props.audienceId, 'contacts');

    if (
        audience &&
        (audience.isRecentlyCreated ||
            (props.currentCount === 0 && audience.members.totalCount > 0))
    ) {
        return (
            <div className={styles['is-building-view']}>
                <EmptyStateLarge
                    title='Your audience is being built'
                    subtitle='Your new audience members may take a few minutes to appear.'
                    icon={<Illustration src='construction-worker' width={250} />}
                />
            </div>
        );
    }

    return null;
}
